import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import type { EventTypeResponse } from "../../models/eventType";

const API_BASE_URL = environment.apiUrl;

/** שליפת כל סוגי האירועים */
export const getEventTypes = createAsyncThunk<
  EventTypeResponse,
  void,
  { rejectValue: string }
>("eventType/GetEventTypes", async (_, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}EventType/GetEventTypes`);

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: EventTypeResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch event types");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
